import React, { Component } from 'react';
import env from '../../config/env'
import Button from '../../components/Form/Button/Button';
import OutOfHours from '../../components/LiveChat/OutOfHours';
import ChatDownTime from '../../components/LiveChat/ChatDownTime';
import './SiteDown.scss';
import '../Header/header.scss';

/** @extends {Component} */
class SiteDown extends Component {
    render() {
        return (
            <div>
                <header className="header">
                    <div className="header__wrapper">
                        <a href={`${env.productPageUrl ? `${env.productPageUrl}/` : '/'}`}>
                            <div className="header__logo" />
                        </a>
                    </div>
                </header>

                <div className="error-layout__content">
                    <section className="hero">
                        <div className="error_title">
                            <h2>The online dashboard is temporarily unavailable.</h2>
                        </div>
                        <div className="error_info">
                            <p>We're really sorry to be holding you up today! We're working hard to get it back up and running.<br /><br />Please check back here soon.</p>
                        </div>
                        <div className="button-container">
                            <Button label='Back' onClick={() => window.location.href = env.productPageUrl + '/'} />
                        </div>
                    </section>
                </div>
                <OutOfHours />
                <ChatDownTime />
            </div>
        );
    }
}

export default SiteDown;